class VideoTestimonialCard extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('.vt-video');
    this.btnPlay = this.querySelector('.vt-btn-play');
    this.btnVolume = this.querySelector('.vt-btn-volume');
    this.btnNext = this.querySelector('.vt-btn-next-avatar');
    this.iconPlay = this.querySelector('.icon-play');
    this.iconPause = this.querySelector('.icon-pause');
    this.iconMute = this.querySelector('.icon-mute');
    this.iconUnmute = this.querySelector('.icon-unmute');
    this.loader = this.querySelector('.vt-loader');

    this.prevBtn = this.querySelector('.vt-btn-prev-avatar');
    this.nextBtn = this.querySelector('.vt-btn-next-avatar');

    // Default state: muted
    if(this.video) {
       this.video.muted = true;
    }

    // Responsive Video & Poster Switcher
    const isDesktop = matchMedia('(min-width: 768px)').matches;
    const graphicEl = this.video || this.querySelector('.vt-poster-only');
    
    if (graphicEl) {
        // Poster logic
        const desktopPoster = graphicEl.getAttribute('data-poster-desktop');
        const mobilePoster = graphicEl.getAttribute('data-poster-mobile');
        
        if (!isDesktop && mobilePoster && mobilePoster !== desktopPoster) {
            if (this.video) graphicEl.setAttribute('poster', mobilePoster);
            else graphicEl.setAttribute('src', mobilePoster);
        }

        // Video src logic
        if (this.video) {
            const desktopVideo = this.video.getAttribute('data-video-desktop');
            const mobileVideo = this.video.getAttribute('data-video-mobile');
            
            if (!isDesktop && mobileVideo && mobileVideo !== desktopVideo) {
                const sourceEl = this.video.querySelector('source');
                if (sourceEl) {
                    sourceEl.setAttribute('src', mobileVideo);
                    this.video.load();
                }
            }
        }
    }

    if (this.btnPlay) {
      this.btnPlay.addEventListener('click', this.togglePlay.bind(this));
    }
    if (this.video) {
      this.video.addEventListener('click', this.togglePlay.bind(this));
      // In JS, also ensure cursor is pointer for video elements to signal clickability
      this.video.style.cursor = 'pointer';
    }
    if (this.btnVolume) {
      this.btnVolume.addEventListener('click', this.toggleVolume.bind(this));
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const slider = this.closest('vt-custom-slider');
        if(slider && slider.swiper) slider.swiper.slidePrev();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const slider = this.closest('vt-custom-slider');
        if(slider && slider.swiper) slider.swiper.slideNext();
      });
    }

    if(this.video) {
      this.video.addEventListener('playing', () => this.setPlayingState(true));
      this.video.addEventListener('pause', () => this.setPlayingState(false));
      this.video.addEventListener('waiting', () => this.setLoadingState(true));
      this.video.addEventListener('canplay', () => this.setLoadingState(false));
      // End of video => reset
      this.video.addEventListener('ended', () => {
         this.video.currentTime = 0;
         this.setPlayingState(false);
      });
    }

  }

  togglePlay(e) {
    if(e) e.preventDefault();
    if(!this.video) return;

    const slide = this.closest('.swiper-slide');
    if (slide && !slide.classList.contains('swiper-slide-active')) {
       return; // Reject play attempt if the user clicks a non-featured thumbnail
    }

    if(this.video.paused) {
      // Pause all other videos
      document.querySelectorAll('video-testimonial-card .vt-video').forEach(vid => {
        if(vid !== this.video && !vid.paused) {
            vid.pause();
        }
      });
      // Play this one
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
          playPromise.catch(err => {
             console.error("Video play error:", err);
             this.setPlayingState(false);
          });
      }
    } else {
      this.video.pause();
    }
  }

  toggleVolume(e) {
    if(e) e.preventDefault();
    if(!this.video) return;

    this.video.muted = !this.video.muted;
    if(!this.video.muted) {
       this.video.volume = 1.0;
    }
    
    if(this.video.muted) {
       this.iconMute?.classList.remove('hidden');
       this.iconUnmute?.classList.add('hidden');
    } else {
       this.iconMute?.classList.add('hidden');
       this.iconUnmute?.classList.remove('hidden');
    }
  }

  setPlayingState(isPlaying) {
    this.setLoadingState(false);
    if(isPlaying) {
      this.iconPlay?.classList.add('hidden');
      this.iconPause?.classList.remove('hidden');
    } else {
      this.iconPlay?.classList.remove('hidden');
      this.iconPause?.classList.add('hidden');
    }
  }

  setLoadingState(isLoading) {
    // Loader has been removed by request
  }
}

class VtCustomSlider extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    
    init() {
        if (typeof Swiper !== 'undefined') {
            const mobileWidth = parseFloat(this.getAttribute('data-mobile-width')) || 90;
            const mobileGap = parseFloat(this.getAttribute('data-mobile-gap')) || 10;
            const desktopGap = parseFloat(this.getAttribute('data-desktop-gap')) || 30;
            const mobileSlides = 100 / mobileWidth;

            this.swiper = new Swiper(this, {
               slidesPerView: mobileSlides,
               centeredSlides: false,
               spaceBetween: mobileGap,
               slideToClickedSlide: true,
               loop: false,
               breakpoints: {
                  768: { slidesPerView: 1.3, spaceBetween: mobileGap, centeredSlides: true },
                  1024: { slidesPerView: 1.5, spaceBetween: desktopGap, centeredSlides: true }
               }
            });
            
            this.swiper.on('slideChange', () => {
                 document.querySelectorAll('video-testimonial-card .vt-video').forEach(vid => {
                     vid.pause();
                 });
            });
        } else {
            console.error("Swiper is not available globally");
        }
    }
}

if (!customElements.get('video-testimonial-card')) {
  customElements.define('video-testimonial-card', VideoTestimonialCard);
}
if (!customElements.get('vt-custom-slider')) {
  customElements.define('vt-custom-slider', VtCustomSlider);
}
